import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { AlertComponent, MbsPopupType } from 'mbs-ui-kit';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';

import { I18NextPipe } from 'angular-i18next';
@Component({
  selector: 'mbs-tfa-configure-alert',
  templateUrl: './tfa-configure-alert.component.html',
  standalone: true,
  imports: [CommonModule, AlertComponent, I18NextPipe]
})
export class TfaConfigureAlertComponent {
  authFacade = inject(AuthFacade);

  protected readonly alertType = MbsPopupType;
}
